import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'font-semibold transition-all duration-200 border-industrial focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:ring-offset-2 focus:ring-offset-dark-bg disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-yellow text-dark-bg border-2 border-brand-yellow hover:bg-brand-yellow-dark hover:border-brand-yellow-dark active:scale-95',
    secondary: 'bg-dark-surface text-white border-2 border-dark-border hover:border-brand-yellow active:scale-95',
    outline: 'bg-transparent text-white border-2 border-white hover:bg-white hover:text-dark-bg active:scale-95'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled} {...props} data-id="element-606">
      {children}
    </button>;
}